<template>
  <div v-if="EstaVacioLosDatos(paginaWeb) == false" class="container-fluid px-0">
    <h1 class="page-title letraDelTitulo enMayusculas col-12">{{paginaWeb.Titulo}}</h1>
    <div v-bind:class="paginaWeb.TipoContenedor.Nombre">
      <h6 v-if="paginaWeb.TextoDePresentacion != null" class="page-text col-12 px-5 my-3">{{paginaWeb.TextoDePresentacion}}</h6>
      <div class="row px-lg-5">
        <Seccion v-for="seccionDeLaPaginaWeb in paginaWeb.SeccionesDeLaPaginaWeb" v-bind:key="seccionDeLaPaginaWeb.SeccionDeLaPaginaWebId" :seccionDeLaPaginaWeb="seccionDeLaPaginaWeb" :nombreDelComponente="'seccion_' + seccionDeLaPaginaWeb.SeccionDeLaPaginaWebId"></Seccion>
      </div>
    </div>
    <div id="inferior-superior-menu" class="w-100">
    </div>
  </div>
</template>

<script>
  import enumeraciones from "@/../static/js/enumeraciones";
  import enumeraciones_sicpo from "@/../static/js/enumeraciones/sicpo.js";
  import api from '@/../static/js/api'
  import axios from 'axios'

  import Seccion from "@/components/PaginaOficial/PaginaInformativa/Seccion.vue"

  export default {
    data() { 
      return {
        enumeraciones, 
        enumeraciones_sicpo,
        TIPO_ROL_DE_ARCHIVO: 1,
        paginaWeb: {},
        nombreDeVariableDelComponente: "cargoPaginaOficial"
      }
    },
    components: {
      Seccion
    },
    methods: {
      CargaLaPagina: function(rutaDeLaPagina) {
        let parametros = {
          URL: rutaDeLaPagina,
          EsPrueba: this.enumeraciones.EsPrueba
        }
      
        axios.post(api.conexion + api.SICPO.sistema.paginaweb.paginaoficial.ObtenLaPaginaWebPorMedioDeURL, parametros)
          .then(respuesta =>{
            if (respuesta.data.SiHayError) {
              console.error(respuesta.data);
              this.YaTermineDeCargar(this.enumeraciones_sicpo.EstadosDeCarga.Error);
            } else {
             // console.log("respuesta:::::::::",respuesta.data.PaginaWeb)
              this.paginaWeb = respuesta.data.PaginaWeb;
              this.EstableceElTituloDeLaVentana();
              this.YaTermineDeCargar(this.enumeraciones_sicpo.EstadosDeCarga.Cargado);
            //  if(rutaDeLaPagina == '/Web/ConstanciaDeAntecedentes')
            //   $('#exampleModal').modal('show');
               
            }
          }).catch(excepcion => {
            console.log(excepcion);
            this.YaTermineDeCargar(this.enumeraciones_sicpo.EstadosDeCarga.Error);
          });
      },
      YaTermineDeCargar: function(estatus) {
        this.$emit("marcaLaCargaYVerifica", this.nombreDeVariableDelComponente, estatus);
       
      },
      EstaVacioLosDatos: function(objeto) {
        return objeto === undefined || objeto === null || Object.keys(objeto).length === 0 ? true : false;
       
      }, 
      EstableceElTituloDeLaVentana: function() {
        let tituloDeLaPaginaWeb = "Poder Judicial del Estado de Aguascalientes";

        if(Object.keys(this.paginaWeb).length > 0) {
          tituloDeLaPaginaWeb = this.paginaWeb.Titulo + " - " + tituloDeLaPaginaWeb;
        }
$('#exampleModalCenter').modal('show');
        document.title = tituloDeLaPaginaWeb;
      }
    },
    mounted() {
      $('#exampleModalCenter').modal('show');
      this.$emit("marcaLaCargaYVerifica", this.nombreDeVariableDelComponente, this.enumeraciones_sicpo.EstadosDeCarga.Cargando);
      $('#exampleModalCenter').modal('show');
      this.CargaLaPagina(this.$route.path);
      $('#exampleModalCenter').modal('show');
    }
  }
</script>

<style scoped>
  #inferior-superior-menu {
    display: flex;
    height: 30px;
    min-height: 30px;
    max-height: 30px;
    background-color: rgb(255, 255, 255);
    /* z-index: 10 !important; */
    position: relative;
  }

  .enMayusculas {
    text-transform: uppercase;
  }

  .page-title {
    /*background-color: rgb(50,50,50);*/
    background-color: rgb(0,117,115);
    color: #FFF;
    padding: 2vh 20vw;
  }

  @media (max-width: 600px) {
    .page-title{
      font-size: 2em;
    }

    h2{
      font-size: 1.8em;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/PaginaOficial/PaginaInformativa/Index.vue